export default "__VITE_PUBLIC_ASSET__d00acaeb__"